<template>
    <div class="cards">
        <div class="card-skeleton" :key="skeleton"  v-for="skeleton in skeletons">
            <Skeleton :key="skeleton" />  
        </div>
    </div>
</template>

<script>
import Skeleton from "@/components/SkeletonCard";

export default {
  name: "skeletonContainer",
  components: {
    "Skeleton": Skeleton
    },
  data: function() {
      return {
          skeletons: 10,
      }
  },
  props: ["loadSkeletons"]
}  
</script>

<style lang="scss">
.card-skeleton {
  padding: 16px;
  border-radius: 4px;

  background: #ffffff;
  color: #b5b5b5;
  position: relative;
  box-shadow: 0 0 50px 5px rgba(201, 201, 201, 0.25);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 0 50px 10px rgba(201, 201, 201, 0.6);
    z-index: 2;
    cursor: pointer;
  }

  &-image {
    width: 20px;
    height: 20px;
  }

  &-stats {
    display: flex;
    align-items: center;

    p {
      margin: 0;
    }
  }

  &-sparkline {
    margin-top: 1rem;
  }


  &-content {
    text-transform: uppercase;
    font-size: 16px;
    color: #aabbc7; //#9A9E9E;
    position: relative;

    display: grid;

    @media (max-width: 480px) {
      font-size: 14px;
    }

    strong {
      color: rgb(117, 131, 138);
    }

    &-rank {
      font-size: 12px;
      margin-left: auto; // To force it to the right
    }

    &-title {
      font-size: 18px;
      display: flex;
      align-items: center;
    }

    &-price {
      padding: 0;
      margin: 0 0 8px 0;
      font-size: 24px;
      color: #000000;
    }

    &-divider {
      left: 20px;
      top: 10px;
      width: 1px;
      height: calc(100% - 20px);
      background: #ececec;
    }

    &-time {
      background: #b5b5b5;
      border-radius: 4px;
      color: white;
      padding: 4px;
      font-size: 12px;
      display: inline;
      margin-left: 8px;
    }

    &-name,
    &-price,
    &-divider {
      margin: 0;
    }

    &-name {
      margin-left: 4px;
    }
  }
}


.card-skeleton {
  .card-content {
    &-name {
      width: 100%;

      div {
        margin: 0;

        &:first-child {
          background: rgba(189, 189, 189, 0.5);
          height: 20px;
          width: 160px;
        }

        &:nth-child(2) {
          background: rgba(189, 189, 189, 0.5);
          height: 20px;
          width: 50px;
          margin-left: auto;
        }
      }
    }

    &-price {
      margin-top: 10px;
      background: rgba(189, 189, 189, 0.7);
      height: 30px;
      width: 160px;
    }

    &-stats {
      margin-top: 10px;

      .empty-time {
        background: rgba(189, 189, 189, 0.3);
        height: 20px;
        width: 80px;
        margin: 5px 0;
      }
    }
  }
}
</style>      


// WEBPACK FOOTER //
// src/components/SkeletonCardContainer.vue